import React from 'react';
import ColumnDefinition from '../../../infrastructure/types/DataGrid/ColumnDefinition';
import FieldDefinition from '../../../types/common/FieldDefinition';
import CustomIcon from '../../Common/BootstrapIcons/Custom/CustomIcon';
import iconTooltip from '../../Common/BootstrapIcons/Tooltip/IconTooltip';
import { ReactComponent as CopyIcon } from '../../Common/BootstrapIcons/copy.svg';
import SelectOption from '../../../infrastructure/types/SelectOption';
import SelectList from '../../Common/SelectList/SelectList';

const getColumns = (
    onCopyFieldClick: (number: number) => void,
    isReadOnly: boolean,
    getFieldReferences: (number: number, aggregationNumber: number) => SelectOption[],
    onFieldSelected: (value: string) => void,
    aggregationNumber:number
): ColumnDefinition<FieldDefinition>[] => {

    let columns: ColumnDefinition<FieldDefinition>[] = [
        {
            header: 'Reference',
            getContent: x => (x.id as number).toString(),
            className: 'break-all',
            width: '110px'
        },
        {
            header: 'Field Name',
            getContent: x => x.name,
        },
        {
            header: 'Data Type',
            getContent: x => x.type
        },
        {
            header: '',
            getContent: x =>
                <div className='display-flex justify-content-end'>
                    <SelectList
                        className="border-none width-110px"
                        options={[{ value: 'References', text: 'References' } as SelectOption].concat(getFieldReferences(x.id as number, aggregationNumber))}
                        value={x.name}
                        onChange={(value, event) => { onFieldSelected(value) }}
                    />
                </div>,
        },
        {
            header: '',
            getContent: x =>
                <div className="float-right display-flex">
                    <button className="custom-icon-button" onClick={() => {
                        onCopyFieldClick(x.id as number)
                    }
                    } disabled={isReadOnly}>
                        <CustomIcon icon={CopyIcon} title={iconTooltip.copy} />
                    </button>
                </div>,
            width: '40px'
        }
    ];

    return columns;
};

export {
    getColumns
};